/* eslint-disable */
var notificationCenter = require('./dist/notification-center');

module.exports = notificationCenter;
